import {
    CREATE_GLOBAL_NOTE,
    DELETE_GLOBAL_NOTE,
    EDIT_GLOBAL_NOTE,
    GET_CLIENT_NOTES,
    GET_GLOBAL_NOTES,
    GET_NOTE_BY_ID,
    VIEW_NOTE,
} from './note.type';

export const getGlobalNotes = (id, onModel, data, load) => {
    return {
        type: GET_GLOBAL_NOTES,
        payload: { id, onModel, data, load },
    };
};

export const getClientNotes = (clientId, params, load) => {
    return {
        type: GET_CLIENT_NOTES,
        payload: { clientId, params, load },
    };
};

export const getNoteById = (noteId) => {
    return {
        type: GET_NOTE_BY_ID,
        payload: { noteId },
    };
};

export const createGlobalNote = (body, requestParams) => {
    return {
        type: CREATE_GLOBAL_NOTE,
        payload: { body, requestParams },
    };
};

export const editGlobalNote = (fId, id, body, onModel, requestParams) => {
    return {
        type: EDIT_GLOBAL_NOTE,
        payload: { fId, id, body, onModel, requestParams },
    };
};

export const deleteGlobalNote = (id, requestParams) => {
    return {
        type: DELETE_GLOBAL_NOTE,
        payload: { id, requestParams },
    };
};

export const viewNote = (body) => {
    return {
        type: VIEW_NOTE,
        payload: { body },
    }
}